import { APP_DOWNLOAD_IMAGES, FRONTIFY_URL } from '@shared/utils';

// Image URLs for AdditionalInformationSection
const ADDITIONAL_INFORMATION_IMAGES = {
  APP_STORE: APP_DOWNLOAD_IMAGES.APP_STORE,
  GOOGLE_PLAY: APP_DOWNLOAD_IMAGES.GOOGLE_PLAY,
  VISA: {
    light: `${FRONTIFY_URL}UdWL366nqvZ83DK9JWii.svg`,
    dark: `${FRONTIFY_URL}BrCwHuDxADAjjm2rwwFc.svg`,
  },
  MASTERCARD: {
    light: `${FRONTIFY_URL}YCc2Mqa8EFtTMtpvyYQM.svg`,
    dark: `${FRONTIFY_URL}seSuNigaU4LkFVRj9VQp.svg`,
  },
  MUCH_BETTER: {
    light: `${FRONTIFY_URL}XysjwA6Wp4tMhRXYUtwv.svg`,
    dark: `${FRONTIFY_URL}SdZwpW5pDJzzAqLHGs8T.svg`,
  },
  APPLE_PAY: {
    light: `${FRONTIFY_URL}VkDbJ52LSY1ovKCvKjfr.svg`,
    dark: `${FRONTIFY_URL}tpzZAsHRGnG65F9CEVRJ.svg`,
  },
  PAY_BY_BANK: {
    light: `${FRONTIFY_URL}ec4q7WRamXC58q2s4aRa.svg`,
    dark: `${FRONTIFY_URL}RxzAK5bosNQBSxMXpGPv.svg`,
  },
  TRUSTLY: `${FRONTIFY_URL}QUYippaJvkpnNCefEC3b.svg`,
  CLIMATE_PLEDGE: `${FRONTIFY_URL}Jg4EfaYAjWMSQZCa6sVF.svg`,
  EGR_POWER_50: {
    light: `${FRONTIFY_URL}pfHJPB28SP9PyqCnCdJL.png`,
    dark: `${FRONTIFY_URL}HFpbXAHTNRiZKMqgRU8D.png`,
  },
  RCHF: `${FRONTIFY_URL}oSNGXWKe67gDA9F8PQhG.svg`,
  SCHF: {
    light: `${FRONTIFY_URL}bd7tLmN5uXKCFW5qCkaQ.svg`,
    dark: `${FRONTIFY_URL}vSvhgsKNkdRCbydxQhuv.svg`,
  },
  GAMBLERS_HELP: `${FRONTIFY_URL}5zvWtcfPgK5bGJeADNmR.png`,
  RESET_APP: {
    light: `${FRONTIFY_URL}ZmkTZ79M3gYbQg7FQ6r5.png`,
    dark: `${FRONTIFY_URL}NjUXgfgP1mwFsrhpiSQK.png`,
  },
} as const;

export { ADDITIONAL_INFORMATION_IMAGES };
